<template>
  <v-list flat v-if="builder">
    <v-list-item v-for="(obj, ind) in sheme" :key="ind" class="pl-0 pr-3">
      <v-list-item-action class="pt-4">
        <v-icon class="disabled-color">mdi-checkbox-blank-outline </v-icon>
      </v-list-item-action>

      <v-list-item-content class="pb-0 pt-0" style="cursor: pointer">
        <v-card-subtitle
          class="pt-8"
          v-if="obj.value !== 'edit'"
          @click="editLabel($event, ind)"
        >
          {{ obj.label }}
        </v-card-subtitle>
        <v-text-field
          v-if="obj.value === 'edit'"
          v-model="obj.label"
          @blur="setLabel($event, obj, ind)"
          @keypress.enter="setLabel($event, obj, ind)"
          color="primary"
          class=""
        ></v-text-field>
      </v-list-item-content>
      <v-list-item-action class="mt-7">
        <v-icon color="red" @click="remove(ind)">mdi-delete</v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-textarea
      v-if="builder"
      v-model="area"
      :label="$t('components.miscellaneous.serviceProtocolDescription.addNew')"
      rows="1"
      value=""
      auto-grow
      color="primary"
      @input="updateText($event)"
      @blur="action"
      @keypress.enter="action"
    ></v-textarea>
  </v-list>
</template>

<script>
export default {
  props: ["builder", "data", "subtasks"],
  data() {
    return {
      area: null,
      sheme: [],
      text: [],
      availableAttachments: [],
      edittedData: [],
    };
  },

  created() {
    this.setInitalData();
    if (this.subtasks.length !== 0) {
      this.subtasks.forEach((element) => {
        this.text.push(element.description);
      });
      this.action();
    } else if (this.data.length !== 0) {
      this.updateText(this.data);
      this.action();
    }
  },

  methods: {
    setInitalData() {
      this.availableAttachments = [
        {
          title: this.$t(
            "components.miscellaneous.serviceProtocolDescription.edit"
          ),
          value: "edit",
        },
      ];
    },
    updateText(e) {
      let splitedText = [];
      splitedText = e.split(/\r\n|\r|\n|,/);
      this.text = splitedText.filter((elem) => elem !== "");
    },

    updateData() {
      let subtasks = [];
      this.edittedData.forEach((element) => {
        subtasks.push({ description: element });
      });
      this.$emit("update:subtasks", subtasks);
    },

    action() {
      this.text = this.text.map((item) => {
        item.trim();
        if (item[0] === "-" || item[0] === "❒") {
          return item.substring(1, item.length);
        }
        return item;
      });

      this.text.forEach((el, index) => {
        this.sheme.push({
          type: "checkbox",
          label: el,
          value: false,
          attachments: {
            type: "textarea",
            label: this.$t(
              "components.miscellaneous.serviceProtocolDescription.comment"
            ),
            value: "",
          },
        });
        this.edittedData.push(el);
      });

      this.text = [];
      this.area = null;
      this.updateData();
    },

    attachment(index, action) {
      this.editLabel("", index);
    },
    setLabel(event, obj, index) {
      obj.label = event.srcElement.value;
      obj.value = false;
      this.edittedData[index] = event.srcElement.value;
      this.updateData();
    },
    editLabel(event, index) {
      this.sheme[index].value = "edit";
    },
    remove(index) {
      this.sheme.splice(index, 1);
      this.edittedData.splice(index, 1);
      this.updateData();
    },
    changeCheckboxState(event, index) {
      switch (this.sheme[index].value) {
        case false:
          this.sheme[index].value = true;
          break;
        case true:
          this.sheme[index].value = "none";
          break;
        case "none":
          this.sheme[index].value = false;
          break;
      }
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.edit-label:hover {
  color: rgba(0, 0, 0, 1);
}
.disabled-color {
  color: rgba(0, 0, 0, 0.38);
}
</style>
